import React from 'react';
import './ProjectPreviewSkeleton.scss';

const Bar: React.FC<{ w: string; h: number; r?: number; className?: string }> = ({
  w,
  h,
  r,
  className,
}) => (
  <div
    className={`project-skeleton__bar ${className ?? ''}`}
    style={{ width: w, height: h, borderRadius: r ?? 8 }}
  />
);

// Placeholder shown only while the project shell loads (no project data yet). Reuses the real page's
// wrappers so it aligns with the actual layout that renders once the data is available.
const ProjectPreviewSkeleton: React.FC = () => (
  <div className="preview-project-page page-content project-skeleton">
    <div className="page-box">
      <div className="page-box__filters">
        <div className="project-skeleton__header">
          <div className="project-skeleton__title">
            <Bar w="32px" h={32} r={8} />
            <Bar w="220px" h={22} />
          </div>
          <div className="project-skeleton__actions">
            <Bar w="36px" h={36} r={8} />
            <Bar w="36px" h={36} r={8} />
            <Bar w="36px" h={36} r={8} />
          </div>
        </div>
      </div>

      <div className="page-box__stats page-box__stats--without-bottom-padding">
        <div className="project-skeleton__tiles">
          {[0, 1, 2, 3].map((i) => (
            <div className="project-skeleton__tile" key={i}>
              <Bar w="50%" h={12} />
              <Bar w="70%" h={30} />
              <Bar w="40%" h={12} />
            </div>
          ))}
        </div>

        <div className="stats">
          <Bar w="100%" h={320} r={12} className="project-skeleton__chart" />
          <Bar w="100%" h={320} r={12} className="project-skeleton__chart" />
        </div>
      </div>

      <div id="key-prompts">
        <div className="project-skeleton__card">
          <Bar w="240px" h={20} />
          {[0, 1, 2, 3, 4, 5].map((i) => (
            <Bar w="100%" h={22} key={i} />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default ProjectPreviewSkeleton;
